import { ScheduleCommentaryCategory } from "authoring/lib/enum/schedule-commentary-category.mjs"

// Short, inline-sentence-friendly labels for a catalogue group - distinct from
// ScheduleCommentaryCategoryLabels, which are section-heading phrases ("Updated Core Content").
export const ScheduleCommentaryGroupCategoryLabels = {
    [ScheduleCommentaryCategory.CORE]: "Core",
    [ScheduleCommentaryCategory.SPECIALIST_SERVICES]: "Specialist Services",
    [ScheduleCommentaryCategory.FUNCTIONAL_SETS]: "Functional Sets",
}
